import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DateTimeFiltersViewModel from "./ViewModels/DateTimeFiltersViewModel";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import DateTimeComponent from "./DateTimeComponent";

interface IDateTimeFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    isAgent: boolean
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function DateTimeFiltersDialog({ open, setOpen, isAgent, callTableViewModel, setCallTableViewModel }: IDateTimeFiltersDialogProps) {
    const [dateTimeFilters, setDateTimeFilters] = useState<DateTimeFiltersViewModel>(callTableViewModel.filters.dateTimeFilters);

    const confirm = () => {
        const newCallTableViewModel = { ...callTableViewModel };

        newCallTableViewModel.filters.dateTimeFilters = dateTimeFilters;

        setCallTableViewModel({
            ...newCallTableViewModel
        })

        setOpen(false);
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
            <DialogTitle>Date & Time Filters</DialogTitle>
            <DialogContent>
                <DateTimeComponent dateTimeFilters={dateTimeFilters} setDateTimeFilters={setDateTimeFilters} isAgent={isAgent} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}